import api from "./api";
import { ENV } from "../utils/constants";

export type Company = {
  cnpj: string;
  name: string;
  companyBasePath: string;
};

export const listCompany = async () => {
  const response = await api.get(
    `account-settings-p1-${ENV}/crm/account-settings/company`
  );
  return response;
};

export const getSegment = async () => {
  const response = await api.get(
    `fast-models-dsmarketing-v1-${ENV}/${ENV}/company/findSegment`
  );

  return response;
};

export const putCompany = async (data: Company) => {
  const response = await api.put(
    `account-settings-p1-${ENV}/crm/account-settings/company/edit`,
    data
  );

  return response;
};
export const putOnboard = async (onboard: any): Promise<any> => {
  const response = await api.put(
    `account-settings-p1-${ENV}/crm/account-settings/company/onboard`,
    onboard
  );
  return response;
};

export const listSegments = async () => {
  try {
    const response = await api.get(
      `fast-models-dsmarketing-v1-${ENV}/${ENV}/segments/list`
    );

    return response;
  } catch (err) {
    return err;
  }
};

export const putSegment = async (id_segment: number) => {
  try {
    const response = await api.put(
      `fast-models-dsmarketing-v1-${ENV}/${ENV}/company/update`,
      { ID_SEGMENT: id_segment }
    );

    return response;
  } catch (err) {
    return err;
  }
};

export const setTokenCloudMessaging = async (token: string) => {
  const response = await api.post(
    `notification-${ENV}/datasales-client/store-token-web`,
    { token }
  );
  return response.data;
};
